import type { ReactNode } from 'react';

// Moldura comum das telas de auth: logo grande centralizado + subtítulo + conteúdo.
export function AuthLayout({ subtitle, children }: { subtitle: string; children: ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-md">
        <div className="mb-3 flex items-center justify-center gap-5">
          <img src="/logo/svg/bzapper-mark-amber.svg" alt="" width={96} height={96} />
          <span className="text-6xl font-extrabold tracking-tight text-foreground" style={{ fontFamily: 'Sora, system-ui, sans-serif' }}>bZapper</span>
        </div>
        <p className="mb-8 text-center text-sm text-muted-foreground">{subtitle}</p>
        {children}
      </div>
    </div>
  );
}
